import { createFileRoute } from '@tanstack/react-router'
import { AssetPage } from '@/features/assets'
import { assetsSearchSchema } from '@/features/assets/assets-search-schema'

function WorkspaceAssetsPage() {
  const { orgId, workspaceId } = Route.useParams()

  return <AssetPage orgId={orgId} workspaceId={workspaceId} />
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/assets/'
)({
  validateSearch: assetsSearchSchema,
  staticData: { layout: 'fluid' },
  component: WorkspaceAssetsPage,
})
